<template>
  <v-app>
    <v-app-bar app color="#f5f5f5" v-if="$route.name != 'login'">
      <div class="d-flex align-center">
        <!-- Tu logo y redirección -->
        <v-img
          v-if="!isRoleDemo"
          alt="WEC Logo"
          class="shrink mr-2"
          :style="'cursor: pointer'"
          contain
          @click="
            setTab(0);
            $route.name != 'home' ? $router.push({ name: 'home' }) : null;
          "
          src="@/assets/grupo_wec_logo.png"
          transition="scale-transition"
          width="30%"
        />
      </div>

      <!-- Botón menú desplegable para pantallas pequeñas -->
      <v-spacer></v-spacer>
      <v-menu v-if="$vuetify.breakpoint.smAndDown">
        <template v-slot:activator="{ on }">
          <v-icon v-on="on">mdi-dots-vertical</v-icon>
        </template>
        <v-list class="pt-0 pb-0">
          <v-list-item
            :style="
              myTab == 0 ? 'background-color:rgba(231, 231, 231, 0.6)' : null
            "
            class="justify-center"
            @click="goTo(0)"
            ><v-icon>mdi-home</v-icon></v-list-item
          >
          <v-list-item
            :style="
              myTab == 1 ? 'background-color:rgba(231, 231, 231, 0.6)' : null
            "
            @click="goTo(1)"
            >Tiempo real</v-list-item
          >
          <v-list-item
            :style="
              myTab == 2 ? 'background-color:rgba(231, 231, 231, 0.6)' : null
            "
            @click="goTo(2)"
            >Histórico</v-list-item
          >
          <v-list-item
            :style="
              myTab == 3 ? 'background-color:rgba(231, 231, 231, 0.6)' : null
            "
            @click="goTo(3)"
            >Acumulados</v-list-item
          >
          <v-list-item
            :style="
              myTab == 4 ? 'background-color:rgba(231, 231, 231, 0.6)' : null
            "
            @click="goTo(4)"
            >Fabricación</v-list-item
          >
          <v-list-item
            :style="
              myTab == 5 ? 'background-color:rgba(231, 231, 231, 0.6)' : null
            "
            @click="goTo(5)"
            >Notificaciones</v-list-item
          >
          <v-list-item
            :style="
              myTab == 6 ? 'background-color:rgba(231, 231, 231, 0.6)' : null
            "
            class="justify-center"
            @click="goTo(6)"
            ><v-icon>mdi-alert</v-icon></v-list-item
          >
          <v-list-item
            style="background-color: rgba(247, 84, 48, 0.711)"
            @click="logout"
            >Cerrar Sesión</v-list-item
          >
        </v-list>
      </v-menu>
      <!-- Pestañas para pantallas más grandes -->
      <v-tabs
        color="primary"
        v-model="myTab"
        v-if="!$vuetify.breakpoint.smAndDown"
        class="scrollable-tabs"
      >
        <v-spacer></v-spacer>
        <v-tab @click="goTo(0)"><v-icon>mdi-home</v-icon></v-tab>
        <v-tab @click="goTo(1)">Tiempo real</v-tab>
        <v-tab @click="goTo(2)">Histórico</v-tab>
        <v-tab @click="goTo(3)">Acumulado</v-tab>
        <v-tab @click="goTo(4)">Fabricación</v-tab>
        <v-tab @click="goTo(5)">Notificaciones</v-tab>
        <v-tab @click="goTo(6)"> <v-icon>mdi-alert</v-icon></v-tab>
      </v-tabs>

      <!-- Cerrar sesión -->
      <v-tooltip v-if="!$vuetify.breakpoint.smAndDown" bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mt-1 mb-1 mr-xs-1 elevation-1"
            v-on="on"
            @click="logout"
            rounded
          >
            <v-icon>mdi-logout</v-icon>
          </v-btn>
        </template>
        <span>Cerrar Sesión</span>
      </v-tooltip>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "App",
  data: () => ({
    //
  }),
  computed: {
    ...mapState(["tab"]),
    myTab: {
      get() {
        return this.tab;
      },
      set(){
      }
    },
    isRoleAdmin(){
      try {
        const user =  JSON.parse(localStorage.getItem("user"))
      return user.role_name == 'admin'
      } catch (error) {
        return false;
      }
      
    },
    isRoleFabricacion(){
      try {
      const user =  JSON.parse(localStorage.getItem("user"))
      return user.role_name == 'fabricacion'
    } catch (error) {
        return false;
      }
    },
    isRoleDemo(){
      try {
      const user =  JSON.parse(localStorage.getItem("user"))
      return user.role_name == 'demo'
    } catch (error) {
        return false;
      }

    },

    usuario(){
      return JSON.parse(localStorage.getItem('user'));
    }
  },
  created() {
    if (this.$route.name == "historico") {
      this.setTab(2);
    } else if (this.$route.name == "tiempoReal") {
      this.setTab(1);
    } else if (this.$route.name == "accumulative") {
      this.setTab(3);
    } else if (this.$route.name == "fabrication") {
      this.setTab(4);
    } else if (this.$route.name == "notifications") {
      this.setTab(5);
    } else if (this.$route.name == "alarms") {
      this.setTab(6);
    } 
    else {
      this.setTab(0);
    }
  },
  async mounted() {
    await this.cargaInicial();
  },
  methods: {
    ...mapActions([
      "cargaInicial",
      "setTab",
      "setMaquinas",
      "logout",
      "createConnection",
    ]),
    // goToAlarmsPage() {
    //   this.$route.name != 'alarms'? this.$router.push({name:"alarms"}):null
    // },

    goTo(page) {
      switch (page) {
        case 0:
          this.$route.name != "home"
            ? this.$router.push({ name: "home" })
            : null;
          break;
        case 1:
          this.$route.name != "tiempoReal"
            ? this.$router.push({ name: "tiempoReal" })
            : null;

          break;
        case 2:
          this.$route.name != "historico"
            ? this.$router.push({ name: "historico" })
            : null;
          break;
        case 3:
          this.$route.name != "accumulative"
          ? this.$router.push({ name: "accumulative" })
          : null;
          break;
        case 4:
          this.$route.name != 'fabrication'? this.$router.push({name:"fabrication"}):null
          break;
        case 5:
          this.$route.name != "notifications"
            ? this.$router.push({ name: "notifications" })
            : null;
          break;
        case 6:
          this.$route.name != "alarms"
            ? this.$router.push({ name: "alarms" })
            : null;
          break;
        default:
          break;
      }
      this.setTab(page);
    },
  },
};
</script>
<style>
/* Estilos para pestañas desplazables horizontalmente en pantallas pequeñas */
@media screen and (max-width: 600px) {
  /* Cambia 600px por el ancho que prefieras */
  .scrollable-tabs {
    overflow-x: auto;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch; /* Para mejorar el desplazamiento en dispositivos táctiles */
  }

  .scrollable-tabs::-webkit-scrollbar {
    display: none; /* Para ocultar la barra de desplazamiento en navegadores webkit */
  }
}
</style>
